import React from 'react';
import { ColumnButton, ColumnButtonProps } from '../ColumnButton';

type FooterProps = {
  /** Primary action or actions (rendered on the right). Accepts a single config or an array. */
  primaryAction?: ColumnButtonProps | ColumnButtonProps[];
  /** Secondary (non-primary) actions rendered on the left. */
  secondaryActions?: ColumnButtonProps[];
  loading?: boolean;
  onClose?(): void;
};

export function Footer({
  primaryAction,
  secondaryActions,
  loading,
  onClose
}: FooterProps) {
  const primaryActions: ColumnButtonProps[] = Array.isArray(primaryAction)
    ? primaryAction
    : primaryAction
    ? [primaryAction]
    : [];

  const hasActions = Boolean(primaryActions.length || secondaryActions?.length);
  if (!hasActions) return null;

  const isSinglePrimary = primaryActions.length === 1;

  return (
    <div className="sticky bottom-0 flex justify-between py-5 px-6">
      <div className="flex gap-3">
        {secondaryActions?.map((action, index) => (
          <ColumnButton
            key={index}
            size="lg"
            {...action}
            onClick={action.onClick || onClose}
            disabled={action.disabled || loading}
          />
        ))}
      </div>
      <div className="flex gap-3">
        {primaryActions.map((action, index) => (
          <ColumnButton
            key={index}
            size="lg"
            primary={isSinglePrimary ? true : action.primary}
            {...action}
            disabled={action.disabled || loading}
          />
        ))}
      </div>
    </div>
  );
}
